import { call, put, all, fork, takeEvery } from "redux-saga/effects";

import { blogDetailsRedux } from "./reducers";
import { BlogDetailsBySlug } from "@/app/service/Blogs";

function* getBlogDetailSaga(action) {
  try {
    const response = yield call(BlogDetailsBySlug, action.payload);

    yield put(blogDetailsRedux.actions.getBlogDetailsSuccess(response.data));
  } catch (error) {
    yield put(blogDetailsRedux.actions.getBlogDetailsFailure(error));
  }
}

export function* watchBlogDetails() {
  yield takeEvery(
    blogDetailsRedux.actions.getBlogDetailsRequest.type,
    getBlogDetailSaga
  );
}

export default function* blogDetailsSaga() {
  yield all([fork(watchBlogDetails)]);
}
